module.exports = __webpack_public_path__ + "8fd0b9dda58e1cd1ae022ef0e76965c0.jpg";